import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../../services/api";

import {
    FaWallet,
    FaArrowDown,
    FaArrowUp,
    FaExchangeAlt,
    FaPhone,
    FaEnvelope,
    FaCalendarAlt,
    FaCheckCircle,
    FaTimesCircle,
    FaArrowLeft
} from "react-icons/fa";

function PartnerDetails() {

    const { id } = useParams();

    const [partner, setPartner] = useState(null);

    const [walletSummary, setWalletSummary] = useState({
        balance: 0,
        deposit: 0,
        withdraw: 0,
        total_transactions: 0
    });

    const [walletHistory, setWalletHistory] =
        useState([]);

    const [page, setPage] =
        useState(1);

    const [pages, setPages] =
        useState(1);

    const [search, setSearch] =
        useState("");

    const [loading, setLoading] =
        useState(true);

    useEffect(() => {

        loadPartner();

    }, [page, search]);

    const loadPartner = async () => {

        try {

            const token =
                localStorage.getItem(
                    "adminToken"
                );

            const res =
                await API.get(
                    `/admin/partner/${id}?page=${page}&search=${search}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

            setPartner(
                res.data.partner
            );

            setWalletSummary(
                res.data.walletSummary
            );

            setWalletHistory(
                res.data.walletHistory
            );

            setPages(
                res.data.pages
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div className="flex justify-center items-center h-[500px]">

                <div className="text-xl font-semibold">
                    Loading...
                </div>

            </div>

        );

    }

    if (!partner) {

        return (

            <div className="flex justify-center items-center h-[500px]">

                <div className="text-red-500 text-2xl">
                    Partner Not Found
                </div>

            </div>

        );

    }

    return (

        <div>

            {/* Header */}

            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-4xl font-bold">

                        Partner Details

                    </h1>

                    <p className="text-gray-500 mt-2">

                        Complete Partner Information

                    </p>

                </div>

                <Link
                    to="/admin/partners"
                    className="
                        flex
                        items-center
                        gap-2
                        px-5
                        py-3
                        rounded-xl
                        bg-yellow-500
                        text-black
                        font-semibold
                    "
                >

                    <FaArrowLeft />

                    Back

                </Link>

            </div>

            {/* Profile */}

            <div className="
                bg-[#111]
                rounded-3xl
                border
                border-yellow-500/20
                p-8
                mb-8
            ">

                <div className="flex flex-col lg:flex-row items-center gap-8">

                    <div
                        className="
                            w-32
                            h-32
                            rounded-full
                            bg-yellow-500
                            text-black
                            text-5xl
                            font-bold
                            flex
                            items-center
                            justify-center
                        "
                    >

                        {partner.name
                            ?.charAt(0)
                            ?.toUpperCase()}

                    </div>

                    <div className="flex-1">

                        <h2 className="text-4xl font-bold">

                            {partner.name}

                        </h2>

                        <div className="mt-5 grid md:grid-cols-3 gap-5">

                            <div className="flex items-center gap-3">

                                <FaPhone className="text-yellow-500" />

                                <span>

                                    {partner.phone}

                                </span>

                            </div>

                            <div className="flex items-center gap-3">

                                <FaEnvelope className="text-yellow-500" />

                                <span>

                                    {partner.email}

                                </span>

                            </div>

                            <div className="flex items-center gap-3">

                                <FaCalendarAlt className="text-yellow-500" />

                                <span>

                                    {
                                        new Date(
                                            partner.created_at
                                        ).toLocaleDateString()
                                    }

                                </span>

                            </div>

                        </div>

                    </div>

                    <div>

                        {

                            partner.status === "active"

                                ?

                                <span
                                    className="
                                    bg-green-500/20
                                    text-green-400
                                    px-5
                                    py-2
                                    rounded-full
                                    flex
                                    items-center
                                    gap-2
                                "
                                >

                                    <FaCheckCircle />

                                    Active

                                </span>

                                :

                                <span
                                    className="
                                    bg-red-500/20
                                    text-red-400
                                    px-5
                                    py-2
                                    rounded-full
                                    flex
                                    items-center
                                    gap-2
                                "
                                >

                                    <FaTimesCircle />

                                    Inactive

                                </span>

                        }

                    </div>

                </div>

            </div>

            {/* Wallet Summary */}

            <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-6 mb-8">

                <div className="bg-[#111] rounded-2xl p-6">

                    <FaWallet className="text-3xl text-yellow-500 mb-5" />

                    <p className="text-gray-500">

                        Current Wallet

                    </p>

                    <h2 className="text-4xl font-bold mt-3">

                        ₹ {Number(walletSummary.balance).toLocaleString()}

                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl p-6">

                    <FaArrowDown className="text-3xl text-green-500 mb-5" />

                    <p className="text-gray-500">

                        Total Deposit

                    </p>

                    <h2 className="text-4xl font-bold mt-3 text-green-400">

                        ₹ {Number(walletSummary.deposit).toLocaleString()}

                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl p-6">

                    <FaArrowUp className="text-3xl text-red-500 mb-5" />

                    <p className="text-gray-500">

                        Total Withdraw

                    </p>

                    <h2 className="text-4xl font-bold mt-3 text-red-400">

                        ₹ {Number(walletSummary.withdraw).toLocaleString()}

                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl p-6">

                    <FaExchangeAlt className="text-3xl text-blue-500 mb-5" />

                    <p className="text-gray-500">

                        Transactions

                    </p>

                    <h2 className="text-4xl font-bold mt-3">

                        {walletSummary.total_transactions}

                    </h2>

                </div>

            </div>


            {/* Wallet History */}

            <div
                className="
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        p-8
    "
            >

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 mb-8">

                    <div>

                        <h2 className="text-3xl font-bold">

                            Wallet History

                        </h2>

                        <p className="text-gray-500 mt-2">

                            All deposit & withdraw transactions

                        </p>

                    </div>

                    <input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search remarks..."
                        className="
                w-full
                lg:w-80
                bg-black
                border
                border-yellow-500/20
                rounded-xl
                px-5
                py-3
                outline-none
                focus:border-yellow-500
            "
                    />

                </div>

                <div className="overflow-x-auto rounded-2xl">

                    <table className="min-w-full">

                        <thead>

                            <tr className="bg-black">

                                <th className="text-left px-6 py-4">

                                    Date

                                </th>

                                <th className="text-left px-6 py-4">

                                    Type

                                </th>

                                <th className="text-left px-6 py-4">

                                    Wallet

                                </th>

                                <th className="text-right px-6 py-4">

                                    Amount

                                </th>

                                <th className="text-left px-6 py-4">

                                    Remarks

                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                walletHistory.length === 0 ?

                                    <tr>

                                        <td
                                            colSpan={6}
                                            className="
                                    text-center
                                    py-16
                                    text-gray-500
                                "
                                        >

                                            No Wallet History Found

                                        </td>

                                    </tr>

                                    :

                                    walletHistory.map((item) => (

                                        <tr
                                            key={item.id}
                                            className="
                                    border-b
                                    border-yellow-500/10
                                    hover:bg-black/30
                                "
                                        >

                                            <td className="px-6 py-5">

                                                {
                                                    new Date(
                                                        item.created_at
                                                    ).toLocaleString()
                                                }

                                            </td>

                                            <td className="px-6 py-5">

                                                {

                                                    item.transaction_type === "credit"

                                                        ?

                                                        <span
                                                            className="
                                                    px-4
                                                    py-2
                                                    rounded-full
                                                    bg-green-500/20
                                                    text-green-400
                                                    text-sm
                                                "
                                                        >

                                                            Deposit

                                                        </span>

                                                        :

                                                        <span
                                                            className="
                                                    px-4
                                                    py-2
                                                    rounded-full
                                                    bg-red-500/20
                                                    text-red-400
                                                    text-sm
                                                "
                                                        >

                                                            Withdraw

                                                        </span>

                                                }

                                            </td>

                                            <td className="px-6 py-5">

                                                <span
                                                    className="
                                            px-3
                                            py-2
                                            rounded-lg
                                            bg-yellow-500/10
                                            text-yellow-400
                                            text-sm
                                        "
                                                >

                                                    {item.wallet_name}

                                                </span>

                                            </td>

                                            <td className="px-6 py-5 text-right font-semibold">

                                                ₹ {Number(item.amount).toLocaleString()}

                                            </td>

                                            <td className="px-6 py-5">

                                                {item.description || "-"}

                                            </td>

                                        </tr>

                                    ))

                            }

                        </tbody>

                    </table>

                </div>

                {/* Pagination */}

                <div className="flex justify-center gap-3 mt-8">

                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                        className="
                px-5
                py-2
                rounded-xl
                bg-[#222]
                disabled:opacity-40
            "
                    >

                        Previous

                    </button>

                    <span
                        className="
                px-5
                py-2
                rounded-xl
                bg-yellow-500
                text-black
                font-semibold
            "
                    >

                        {page} / {pages}

                    </span>

                    <button
                        disabled={page === pages}
                        onClick={() => setPage(page + 1)}
                        className="
                px-5
                py-2
                rounded-xl
                bg-[#222]
                disabled:opacity-40
            "
                    >

                        Next

                    </button>

                </div>

            </div>
        </div>
    )
}

export default PartnerDetails;